//función que convierte la fecha en formato año, mes, día,(yyyy/mm/dd) hh:mm:ss (horas, minutos y segundos)

function dateNow() {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date()
    return d.getFullYear() + '/' + pad(d.getMonth()+1) + '/' + pad(d.getDate()) 
           + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds())
  } 

  export default dateNow